import type { SwapProtocolIdentifier } from "@opensea/graphql"
import {
  Item,
  ItemAvatar,
  ItemContent,
  ItemSide,
  ItemTitle,
} from "@opensea/next-ui-kit"
import { FlexCenter, FlexColumn, TextBody, Tooltip } from "@opensea/ui-kit"
import { BlurLogo, Bolt, CryptoPunksLogo } from "@opensea/ui-kit/icons"
import { useTranslations } from "next-intl"
import { useSwapProtocols } from "@/components/currencies/activity/use-swap-protocols"
import { SWAP_PROTOCOLS } from "@/hooks/query-param/use-relayer-query-param"

export function AggregatorHoverable() {
  const t = useTranslations("AggregatorHoverable")

  return (
    <Tooltip content={<MarketplacesContent />}>
      <FlexCenter className="gap-1" color="text-secondary">
        <Bolt size={16} />
        <TextBody size="xs">{t("aggregating")}</TextBody>
      </FlexCenter>
    </Tooltip>
  )
}

// TODO: Fetch from BE
const marketplaces = [
  {
    text: "Blur",
    icon: BlurLogo,
  },
  {
    text: "CryptoPunks",
    icon: CryptoPunksLogo,
  },
]

function MarketplacesContent() {
  const t = useTranslations("AggregatorHoverable")
  const { getName, getLogo } = useSwapProtocols()

  const swapProtocols = SWAP_PROTOCOLS.map(
    (identifier: SwapProtocolIdentifier) => ({
      text: getName(identifier),
      icon: getLogo(identifier)?.icon,
    }),
  ).filter(protocol => protocol.icon && protocol.text)

  const allProtocols = [...swapProtocols, ...marketplaces]

  return (
    <FlexColumn className="w-[250px] font-sans">
      <div className="px-2 py-1.5">{t("liquidityFrom")}</div>

      {allProtocols.map(({ text, icon: Icon }, idx) => (
        <Item className="px-2 py-1.5" key={`${text}-${idx}`} variant="unstyled">
          <ItemAvatar icon={Icon} size={20} />
          <ItemContent>
            <ItemTitle>{text}</ItemTitle>
          </ItemContent>
          <ItemSide>
            {/* TODO: Move to DS? */}
            <ItemTitle className="rounded bg-success-1 bg-opacity-[0.08] px-1.5 py-0.5 text-success-1">
              {t("active")}
            </ItemTitle>
          </ItemSide>
        </Item>
      ))}
    </FlexColumn>
  )
}
